(function (upp) {
    'use strict';

    upp.controller('upp.restaurant.RestaurantCtrl', ['$scope', 'restaurantService', 'appi',
            function ($scope, restaurantService, appi) {

                appi.ui.changeActualOption({moduleKey2Display: 'restaurant', navbarKey: 'restaurant'});
                appi.ui.showPageLoadingMsg();

                $scope.content = [];

                restaurantService.getCategories().then(function(data) {
                    $scope.content = data;
                    appi.ui.hidePageLoadingMsg();
                });
            }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/restaurant/controllers/restaurant-controller.js